import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestGenerateProductVariantSKUAndShortId } from "./generateProductVariantSKUAndShortId.request";
import { GenerateProductVariantSKUAndShortIdResponse } from "./generateProductVariantSKUAndShortId.types";

const useGenerateProductVariantSKUAndShortId = (
  options?: MutationOptions<
    GenerateProductVariantSKUAndShortIdResponse,
    ApiServiceError<ApiError>
  >
) => {
  return useMutation({
    mutationFn: requestGenerateProductVariantSKUAndShortId,
    ...options
  });
};

export default useGenerateProductVariantSKUAndShortId;
